import { useMutation } from '@tanstack/react-query';
import { CreateUserDto, UserWalletManageService } from 'services/openapi';

type CreateUserMutationVariables = CreateUserDto;

export const useCreateUserMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, CreateUserMutationVariables>({
      mutationFn: (variables: CreateUserMutationVariables) => {
        return UserWalletManageService.userManageControllerCreateUser(
          variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
